import React from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import CompanyHeader from '../Config/CompanyHeader';


class PopReservationReceipt extends React.Component {

    state={
       receipts:this.props.record
    }

    

  render(){
	  const record=this.state.receipts;
      return (
        <div className="modal" id="modal_payment_summary">
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            
        <div className="modal-content modal-content-demo shadow">
            <div className="modal-header">
                <h6 className="modal-title">Receipt</h6>
                <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
            </div>
            <div className="modal-body">
               
            
                <div className="row">
						{record && <div className="col-lg-12 col-md-12">
							<div className="card custom-card">
								<div className="card-body">
									<div className="d-lg-flex">
                                        <h2 className="card-title mb-1">
                                            {record.payment_ref}<br/>
                                            {"RESERVATION RECEIPT"}
                                        </h2>
										<div className="ml-auto">
                                            <p className="mb-1"><span className="font-weight-bold">Receipt Date :</span> {record.payment_date.long_date}</p>
										</div>
									</div>
									<hr className="mg-b-40"/>
									<div className="row">
										<div className="col-lg-6">
											<CompanyHeader/>
										</div>
										<div className="col-lg-6 text-right">
											<p className="h3">Payment From:</p>
											<address>
                                                {record.invoice.organisation.title}<br/>
                                                {"By: " + record.depositor_name}<br/>
                                                {"    " + record.depositor_contact}<br/>
											</address>
										</div>
									</div>
									<div className="table-responsive mg-t-40">
										<table className="table table-invoice table-bordered">
											<thead>
												<tr>
                                                    <th className="wd-25p">Invoice No.</th>
                                                    <th className="wd-25p">Invoice Amount.</th>
                                                    <th className="wd-25p">Amount Paid.</th>
													<th className="wd-25p">Bal. After</th>
												</tr>
											</thead>
											<tbody>

                                                    <tr>
                                                    <td className="tx-12">{record.invoice.invoice_ref}</td>
													<td>{record.invoice.ledger.total.amount_c}</td>
													<td>{record.amount.amount_c}</td>
													<td>{record.balance_after.amount_c}</td>
												</tr>
												
												<tr>
													<td className="valign-middle" colSpan="2" rowspan="4">
														<div className="invoice-notes">
															
															<label className="main-content-label tx-13">CASHIER SIGN.</label>
															
														</div>
													</td>
													<td className="tx-right">Total Paid</td>
                                                    <td className="tx-right" colSpan="2">UGX.{record.amount.amount_c}</td>
												</tr>
												
												
											</tbody>
										</table>
									</div>
								</div>
								
                                
                                <div className="card-footer text-right">
                                   
									{/* <button type="button" className="btn ripple btn-secondary mb-1"><i className="fe fe-send mr-1"></i> Send Invoice</button> */}
									<button type="button" className="btn ripple btn-info mb-1"><i className="fe fe-printer mr-1"></i> Print</button>
								</div>
							</div>
						</div>}

                        {!record && <ActivityLoader/>}
					</div>




            
            </div>
          
        </div>


        </div>
    </div>
      )
    
 
  }
}

export default PopReservationReceipt;